
/**
 * TODO: include specific css here
 * override some, which breaking core note model that will need to change anyway
 */

var FlashNote = require('./flashNote'),
    NoteView = require('../note');

module.exports = FlashNote.extend({

    onRender: function() {

        FlashNote.prototype.onRender.apply(this, arguments); /* note: always new */

        this.$el.addClass('flashback edit-mode');
        this.ui.noteHeader.remove();
        this.ui.emailWr.prependTo(this.ui.submitRow);

        this.recipientIsCurrentUser =
            this.model.get('accessGroup') === this.options.channel.request('notes:getUserPrivateID');

        this.recipientIsCurrentUser &&
            this.ui.emailWr.addClass('hide');

        this.delegateEvents();
        this.bindKeyboardEvents(); //(delegate turns them off ... this should all be cleaned up)

        setTimeout( _.bind( function() {
            this.ui.textArea.focus();
        }, this), 0);

    },

    // temp override since not reading from DOM
    _recipientIsCurrentUser: function() {

        return this.recipientIsCurrentUser;

    },

    templateHelpers: _.extend( {}, FlashNote.prototype.templateHelpers, {

        isFlashBackNote: function() {
            return true;
        }

    }),

    // TODO: fix up -- interferes with delegateCollapsibleHandlers -- (mousedown)
    events: {
        'mousedown @ui.okBtn':      'save', /* mousedown caught b/f click -- even though the parent */
        'mousedown @ui.cancelBtn':  'cancel'
    },
    /* need to override these ..... trigger event from the view to the collection view .... */
    keyboardEvents: {

        'shift+enter':  function() {
            NoteView.prototype.keyboardEvents['shift+enter'].apply(this, arguments);
           this.save();
        },
        'esc': function() {
            //note --- a string so the fn application will err --- not needed here anyway
            this.cancel();
        }

    },
    /* don't change the activeNote -- (its still the parent, these are an outlier */
    save: function() {
        this.options.channel.trigger('noteView:enterSave', this);
    },

    // Note: no need to worry about active note
    cancel: function() {

        this.options.parentView.uiModel.set('replyMode', false);
    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/flash/flashBackReply.js
 ** module id = 283
 ** module chunks = 0
 **/